module.exports = __webpack_public_path__ + "static/media/miniClock.a5d47473.svg";